import React from 'react';
import '@testing-library/jest-dom';
import { render } from '@testing-library/react';
import { Avatar } from './Avatar';

describe('Avatar', () => {
	it('Name', () => {
		const { getByTestId } = render(
			<Avatar data-testid="avatar" name="Rose Tico" />
		);
		const el = getByTestId('avatar');

		expect(el).toBeVisible();
		expect(el).toHaveTextContent('RT');
	});

	it('Name & Image', () => {
		const { getByTestId } = render(
			<Avatar
				data-testid="avatar"
				name="Rose Tico"
				image="https://placehold.it/100"
			/>
		);
		const el = getByTestId('avatar');

		expect(el).toBeVisible();
		expect(el).not.toHaveTextContent('RT');
	});

	it('Name & Icon', () => {
		const { getByTestId } = render(
			<Avatar data-testid="avatar" name="Rose Tico" icon="email" />
		);
		const el = getByTestId('avatar');

		expect(el).toBeVisible();
		expect(el).not.toHaveTextContent('RT');
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Avatar
				name="Rose Tico"
				image="https://placehold.it/100"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
